import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import { DEFAULT_CIRCLE_SIZE_PIXELS } from '../../constants';

const useStyles = makeStyles({
    circle: {
        borderRadius: '50%',
    },
});

const Circle = ({ color, sizePixels = DEFAULT_CIRCLE_SIZE_PIXELS }) => {
    const classes = useStyles();

    return (
        <div
            className={classes.circle}
            style={{ backgroundColor: color, height: `${sizePixels}px`, width: `${sizePixels}px` }}
        />
    );
};

Circle.propTypes = {
    color: PropTypes.string.isRequired,
    sizePixels: PropTypes.number,
};

export default Circle;
